<!-- SMS modal -->
<div class="modal fade" id="sendSmsModal">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Send SMS for <strong class="text-muted">{{frmSMS.source}} / {{frmSMS.itemNo}}</strong></h4>
                <button type="button" class="close" (click)="fnCloseSendSmsModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body p-4">
                <!-- {{frmSMS|json}} -->
                <form class="form-horizontal" *ngIf="!message">
                    <div class="form-group row">
                        <label class="col-12">
                            To
                            <!-- <i class="fa fa-edit pull-right pointer" aria-hidden="true"></i> -->
                        </label>
                        <div class="col-12">
                            <textarea class="form-control" rows="1" name="numbers" [(ngModel)]="frmSMS.numbers" required></textarea>
                        </div>
                    </div> 
                    <div class="form-group row">
                        <label class="col-12">
                            Message
                            <!-- <i class="fas fa-edit pull-right pointer" aria-hidden="true"></i> -->
                        </label>
                        <div class="col-12">
                            <textarea class="form-control" rows="4" name="message" [(ngModel)]="frmSMS.message" required></textarea>
                        </div>
                    </div>  
                    <div class="form-group text-right">
                        <button type="submit" class="btn btn-primary btn-sm mr-2"> <i class="fa fa-paper-plane" aria-hidden="true"></i> Send</button>
                        <button type="button" class="btn btn-white btn-sm" (click)="fnCloseSendSmsModal()">Cancel</button>
                    </div>
                </form>
                <p *ngIf="message" class="text-center text-success">{{message}}</p>
            </div>
        </div>
    </div>
</div>